import { RedditUsersListQueryItems, UserAccessEntityType } from 'wb-reddit/graphql/generated';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { isSpotify, AvatarEntity } from '@aleph/shared-components';

export const REFRESH_TOKEN_URI = `${import.meta.env.VITE_API_PATH}/auth/refresh-token/pn_re/user/`;

export const NETWORK = 'pn_tw';

export type AccessBadgeEntityType = {
	name?: string | null,
	type?: string | null
};

export const getPublicClient = ({ uri }: { uri: string }) => new ApolloClient({
	uri,
	cache: new InMemoryCache(),
});

export const getEntityTypeName = (type?: UserAccessEntityType) => {
	// TODO add business
	if (isSpotify()) {
		return 'Advertiser';
	}

	switch (type) {
		case UserAccessEntityType.Agency:
			return 'Advertiser';
	}

	return 'Ad Account';
};

export const getUserInitials = (
	user?: RedditUsersListQueryItems | null,
) => (user ? `${user.userName?.[0] ?? ''}${user.userSurname?.[0] ?? ''}` : '');

/**
 * If no typename is provided or found, defaults to User entity type
 */
export function mapTypeNameToAvatarEntity(entity: any) {
	const typeName = entity?.__typename;

	switch (typeName) {
		case 'AdAccount':
		case 'Client':
			return AvatarEntity.Account;
		case 'UserGroup':
			return AvatarEntity.Team;
		case 'AdvertiserAccount':
		case 'AgencyAccount':
			return AvatarEntity.Advertiser;
		case 'Report':
			return AvatarEntity.Report;
		default:
			return AvatarEntity.User;
	}
}
